import { Address, AddressApi, ProductAccessoriesApi, ProductAccessory } from '@/api';
import { ApiUtils } from '@/common/ApiUtils';
import { AddressExtended } from '@/models/extensions';

export class ProductAccessoryService {
	constructor(private productAccessoriesApi: ProductAccessoriesApi = new ProductAccessoriesApi()) {}

	public async getProductAccessoriesForTransceiver(
		transceiverId: number,
	): Promise<{ accessories?: ProductAccessory[]; errorMessage?: string }> {
		try {
			const response = await this.productAccessoriesApi.getAvailableAccessories(transceiverId);
			return { accessories: response.data?.data ?? [] };
		} catch (e) {
			return ApiUtils.handleApiError(
				e,
				`Failed to get available product accessories for transceiver '${transceiverId}'`,
			);
		}
	}

	public async installProductAccessory(
		accessoryId: number,
		productId: number,
		entityType: string,
		entityId: number,
	): Promise<{ success?: boolean; errorMessage?: string }> {
		try {
			await this.productAccessoriesApi.installAccessory(accessoryId, {
				productId,
				entityType,
				entityId,
			});
			return { success: true };
		} catch (e) {
			return ApiUtils.handleApiError(e, `Failed to install product accessory '${accessoryId}'`);
		}
	}

	public async deactivateProductAccessory(
		accessoryId: number,
	): Promise<{ success?: boolean; errorMessage?: string }> {
		try {
			await this.productAccessoriesApi.deactivateAccessory(accessoryId);
			return { success: true };
		} catch (e) {
			return ApiUtils.handleApiError(e, `Failed to deactivate product accessory '${accessoryId}'`);
		}
	}
}
